import Link from 'next/link'
import { Button } from 'antd'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'src/app/hooks'
import { PlusOutlined } from '@ant-design/icons'
import styles from './ProjectCreateButton.module.scss'

const ProjectCreateButton = () => {
  const { t } = useTranslation()
  const { width } = useWindowSize()

  return (
    <Link href={`/my-projects/create`} legacyBehavior>
      <a>
        <Button
          type='primary'
          htmlType='button'
          icon={<PlusOutlined />}
          className={width < 800 ? styles.buttonMovile: ''}
        >
          {t('Projects.List.Create')}
        </Button>
      </a>
    </Link>
  )
}

export default ProjectCreateButton
